// extracted by mini-css-extract-plugin
export var container = "_63-0";
export var error = "_63-9";
export var label = "_63-5";
export var light = "_63-6";
export var md = "_63-3";
export var sm = "_63-2";
export var thin = "_63-8";
export var thinBold = "_63-7";
export var vertical = "_63-4";
export var xs = "_63-1";